import { create } from 'zustand'
import type { SkuId } from '@yadviga/shared'

export type PaywallReason =
  | 'feature_locked'
  | 'free_quota_exhausted'
  | 'expired'
  | 'manual'

export interface PaywallContext {
  reason: PaywallReason
  feature?: string
  /** Pre-suggested SKU (one-time) for this feature. */
  suggestedSku?: SkuId
  message?: string
}

interface PaywallState {
  open: boolean
  ctx: PaywallContext | null
  show: (ctx: PaywallContext) => void
  hide: () => void
}

export const usePaywallStore = create<PaywallState>((set) => ({
  open: false,
  ctx: null,
  show: (ctx) => set({ open: true, ctx }),
  hide: () => set({ open: false, ctx: null }),
}))

/**
 * Pre-Phase-2 helper that mapped a locked feature key to a one-time SKU we
 * could offer alongside subscription. With one-time SKUs all disabled in
 * Phase 2, this map is now empty — paywall is subscription-only. Kept as a
 * stub so call sites compile; remove altogether once we audit the last use.
 */
const FEATURE_TO_SKU: Record<string, SkuId> = {}

export function suggestedSkuFor(featureKey: string | undefined): SkuId | undefined {
  if (!featureKey) return undefined
  return FEATURE_TO_SKU[featureKey]
}
